/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T10:19:46.053
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getCCBFinBillItemEditInit,
	getCCBFinBillItemView
} from '@api/house/CCBFinBillItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getCCBFinBillItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBFinBillItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
